import React, { useState } from 'react'

import { Alert, Box, Stack, Text } from '@components/ui'
import Configuration from '@utils/configuration'

import EmailForm from './email-form'

const DarkModePage = () => {
  const [emailSubmitted, setEmailSubmitted] = useState(false)
  const nextYear = parseInt(Configuration.activePlanYear, 10) + 1

  return (
    <Stack spacing={4} alignItems="center" justifyContent="center" py={10}>
      <Text variant="avenir24Bold" color="brand.color">
        Plan year {Configuration.activePlanYear} FFM training is no longer available.
      </Text>
      <Box sx={{ maxWidth: 500 }}>
        <Text variant="avenir16" align="center">
          If you would like to be notified when plan year {nextYear} FFM training becomes available
          enter your your email address below.
        </Text>
      </Box>
      {emailSubmitted ? (
        <Alert severity="success">Thank you for submitting your email!</Alert>
      ) : (
        <EmailForm onCreate={() => setEmailSubmitted(true)} />
      )}
    </Stack>
  )
}

DarkModePage.propTypes = {}

export default DarkModePage
